import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "search-bar" }
const _hoisted_2 = { class: "card mb-10" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12 d-flex search-bar-group" }
const _hoisted_5 = { class: "lang-toggle-wrapper form-control" }
const _hoisted_6 = {
  key: 0,
  class: "toggle-label"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode("All ")
const _hoisted_8 = /*#__PURE__*/_createElementVNode("b", null, "Languages ", -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("(2)")
const _hoisted_10 = [
  _hoisted_7,
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = {
  key: 1,
  class: "toggle-label"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("b", null, "English", -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Only")
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = {
  key: 2,
  class: "toggle-label"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("b", null, "Spanish", -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Only")
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = {
  key: 0,
  class: "checkbox-group"
}
const _hoisted_20 = { for: "englishCheckbox" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" English ")
const _hoisted_22 = { for: "spanishCheckbox" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Spanish ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_type_ahead = _resolveComponent("type-ahead")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              class: "toggle-label-wrapper",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($options.toggleLangFilter && $options.toggleLangFilter(...args)))
            }, [
              ($data.dropdownLanguages.length !== 1)
                ? (_openBlock(), _createElementBlock("p", _hoisted_6, _hoisted_10))
                : ($data.dropdownLanguages.length === 1 && $data.dropdownLanguages[0] === 'en')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_11, _hoisted_14))
                  : ($data.dropdownLanguages.length === 1 && $data.dropdownLanguages[0] === 'es')
                    ? (_openBlock(), _createElementBlock("p", _hoisted_15, _hoisted_18))
                    : _createCommentVNode("", true),
              _createVNode(_component_inline_svg, {
                class: "nav-chevron",
                src: "/media/icons/chevron-right-solid.svg",
                style: _normalizeStyle({transform: $data.showLangFilter ? 'rotate(270deg)' : 'rotate(90deg)'})
              }, null, 8, ["style"])
            ]),
            ($data.showLangFilter)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createElementVNode("label", _hoisted_20, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      id: "englishCheckbox",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($data.dropdownLanguages) = $event)),
                      value: 'en'
                    }, null, 512), [
                      [_vModelCheckbox, $data.dropdownLanguages]
                    ]),
                    _hoisted_21
                  ]),
                  _createElementVNode("label", _hoisted_22, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      id: "spanishCheckbox",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($data.dropdownLanguages) = $event)),
                      value: 'es'
                    }, null, 512), [
                      [_vModelCheckbox, $data.dropdownLanguages]
                    ]),
                    _hoisted_23
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_type_ahead, {
            class: "search-terms",
            items: $data.searchResults,
            placeholder: _ctx.$t('searchbar.findBooks'),
            languages: $data.dropdownLanguages
          }, null, 8, ["items", "placeholder", "languages"])
        ])
      ])
    ])
  ]))
}